export default __webpack_public_path__ + "static/pedestals-54cdbb2712e899e289edd09838112eae.jpg";